/**
 * React Query key factory for the Social Media arche.
 *
 * Owned by the arche so the central `client/src/lib/query-keys.ts` does
 * not host per-arche namespaces. See
 * docs/audits/social-media-modularity-audit.md §10 PW-D.
 *
 * The central file re-exports this under `queryKeys.socialMedia` so
 * existing consumers continue to work without change. New code inside
 * this arche should import `socialMediaQueryKeys` directly from here.
 */
export const socialMediaQueryKeys = {
  all: ['social-media'] as const,
  /** Posts visible in a calendar range — keyed by ISO from/to so each range is cached separately. */
  calendarPosts: (from: string, to: string) =>
    [...socialMediaQueryKeys.all, 'calendar', from, to] as const,
};
